import { faRefresh } from '@fortawesome/free-solid-svg-icons'
import { Col, Empty, Space, Table, message, theme } from 'antd'
import React, { useEffect, useState } from 'react'
import { handleError } from '../../../lib/utils'
import { readSystemUsersAggregate } from '../../../Admin/system-users/utils/utils'
import { useDispatch, useSelector } from 'react-redux'
import { ContainerCard } from '../../../reusable-components/AgiliteCards'
import coreReducer from '../../../../core/utils/reducer'
import AddPatient from '../../../Admin/system-users/components/add'
import { columnTemplate } from './utils/templates'
import CoreEnums from '../../../../core/utils/enums'
import DependentsReducer from './utils/depentdents-reducer'
import CustomRow from '../../../reusable-components/CustomRow'
import CustomButton from '../../../reusable-components/CustomButton'
import { readMedicalHistory } from '../../../Admin/patients/utils/utils'
import { deviceDetect } from 'react-device-detect'
import EditPatientProfile from '../../../Admin/system-users/components/EditPatient'

const Dependants = ({ isReception, mainPatient, setFacet, setFormData, refreshView }) => {
  const dispatch = useDispatch()
  const dependantsState = useSelector((state) => state.dependents.data)
  const [receptionData, setReceptionData] = useState([])
  const authState = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    handleGetDependants()
    // eslint-disable-next-line
  }, [])

  const handleGetDependants = async () => {
    let tmpDependants = []
    let tmpDependantsPatientData = []
    let dependantIds = []

    setLoading(true)

    try {
      tmpDependants = await readSystemUsersAggregate({
        mainMemberId: isReception ? mainPatient._id : authState.agiliteUser._id
      })

      dependantIds = tmpDependants.map((dependant) => dependant._id)

      if (dependantIds.length > 0) {
        tmpDependantsPatientData = await readMedicalHistory({ userRef: { $in: dependantIds } })
      }

      tmpDependants.map((dependant) => {
        return (dependant.patientRecord = tmpDependantsPatientData.find(
          (patientRecord) => patientRecord.userRef === dependant._id
        ))
      })

      if (isReception) {
        setReceptionData(tmpDependants)
      } else {
        dispatch(DependentsReducer.actions.setRecords(tmpDependants))
      }
    } catch (e) {
      message.error(handleError(e, true))
    }

    setLoading(false)
  }

  const handleResetFunction = () => {
    dispatch(
      coreReducer.actions.closeTab({
        targetKey: `${CoreEnums.tabKeys.DEPENDANTS}_new`,
        removeBreadcrumb: true
      })
    )
  }

  const handleOpenDependantForm = (record, isNew) => {
    if (!isNew) {
      dispatch(
        coreReducer.actions.addTab({
          key: `${CoreEnums.tabKeys.DEPENDANTS}_${record._id}`,
          closable: true,
          label: `Dependant: ${record.firstName} ${record.lastName}`,
          children: (
            <EditPatientProfile
              dataId={record._id}
              refreshView={handleGetDependants}
              handleRootTabKey={() => CoreEnums.tabKeys.PATIENTS}
              isDependant={true}
              parentId={isReception ? mainPatient._id : authState.agiliteUser._id}
            />
          )
        })
      )
    } else {
      dispatch(
        coreReducer.actions.addTab({
          key: `${CoreEnums.tabKeys.DEPENDANTS}_new`,
          closable: true,
          label: 'New Dependant',
          children: (
            <AddPatient
              isDependant={true}
              mainPatientInfo={mainPatient}
              isReception={isReception}
              refreshView={handleGetDependants}
              resetFunction={handleResetFunction}
              shouldStayOnPage={true}
            />
          )
        })
      )
    }
  }

  const closeTab = () => {
    refreshView()
    dispatch(
      coreReducer.actions.closeTab({
        targetKey: `${CoreEnums.tabKeys.PATIENTS}_${CoreEnums.tabKeys.DEPENDANTS}_${mainPatient._id}`,
        removeBreadcrumb: true
      })
    )
  }

  const { token } = theme.useToken()

  return (
    <ContainerCard title='Family Accounts'>
      <CustomRow justify='center' style={deviceDetect().isMobile ? { textAlign: 'center' } : {}}>
        <Col span={24}>
          <CustomRow className='basic-card'>
            <Col span={24}>
              <Space wrap>
                {isReception ? (
                  <center>
                    <CustomButton size='small' text='Close' type='danger' onClick={() => closeTab()} />
                  </center>
                ) : null}
                <CustomButton
                  text='Add Family Account'
                  size='small'
                  loading={loading}
                  type='primary'
                  style={{
                    backgroundColor: '#1890ff',
                    borderColor: '#1890ff',
                    color: '#ffffff',
                    fontWeight: 500,
                    boxShadow: '0 2px 4px rgba(24, 144, 255, 0.2)'
                  }}
                  onClick={() => {
                    handleOpenDependantForm(
                      { firstName: '', lastName: '', idNo: '', dateOfBirth: '', gender: '', race: '' },
                      true
                    )
                  }}
                />
                {deviceDetect().isMobile ? undefined : (
                  <CustomButton
                    size='small'
                    text='Refresh'
                    icon={faRefresh}
                    iconPosition='end'
                    type='primary'
                    style={{
                      backgroundColor: '#1890ff',
                      borderColor: '#1890ff',
                      color: '#ffffff',
                      fontWeight: 500,
                      boxShadow: '0 2px 4px rgba(24, 144, 255, 0.2)'
                    }}
                    onClick={() => handleGetDependants()}
                  />
                )}
              </Space>
            </Col>
            <Col span={24}>
              {(isReception ? receptionData : dependantsState) &&
                (isReception ? receptionData : dependantsState).length > 0 && (
                  <Table
                    showHeader={!deviceDetect().isMobile}
                    pagination={false}
                    columns={columnTemplate(token)}
                    rowKey={(record) => record._id}
                    onRow={(record) => {
                      return {
                        onClick: () => {
                          handleOpenDependantForm(record, false)
                        }
                      }
                    }}
                    dataSource={isReception ? receptionData : dependantsState}
                    loading={loading}
                  />
                )}
            </Col>
          </CustomRow>
        </Col>
      </CustomRow>
    </ContainerCard>
  )
}

export default Dependants
